import React, { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';

import Loading from '../components/common/Loading';
import { AppErrorPage } from '../components/common/AppError';
import { useAuthStore } from '../store/useAuthStore';
import { isAuthenticatedAppPath } from '../utils/errorNavigation';

const AuthenticatedRoutes = lazy(() => import('./authenticatedRoutes'));

const AuthenticatedCatchAll: React.FC = () => (
  <Suspense fallback={<Loading />}>
    <AuthenticatedRoutes />
  </Suspense>
);

/** Roteamento do catch-all: 404 público ou área autenticada. */
const RouteCatchAll: React.FC = () => {
  const { pathname } = useLocation();
  const authenticated = useAuthStore((state) => state.authenticated);

  if (isAuthenticatedAppPath(pathname) || authenticated) {
    return <AuthenticatedCatchAll />;
  }

  return <AppErrorPage variant="notFound" layout="fullPage" />;
};

export default RouteCatchAll;
